import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Products from './components/Products';
import OrderForm from './components/OrderForm';
import ViewOrder from './components/ViewOrder';
import Fulfillment from './components/Fulfillment';
import { login, logout, isAuthenticated } from './lib/auth';

function App() {
  const [authenticated, setAuthenticated] = useState(isAuthenticated());

  useEffect(() => {
    setAuthenticated(isAuthenticated());
  }, []);

  const handleLogin = async (username: string, password: string) => {
    try {
      await login(username, password);
      setAuthenticated(true);
    } catch (error) {
      // Ensure the error is properly propagated to the Login component
      if (error instanceof Error) {
        throw error;
      } else {
        throw new Error('Login failed. Please try again.');
      }
    }
  };

  const handleLogout = () => {
    logout();
    setAuthenticated(false);
  };

  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={
            !authenticated ? (
              <Login onLogin={handleLogin} />
            ) : (
              <Navigate to="/dashboard" replace />
            )
          } 
        />
        <Route 
          path="/dashboard/*" 
          element={
            authenticated ? (
              <Dashboard onLogout={handleLogout} />
            ) : (
              <Navigate to="/" replace />
            )
          } 
        />
        <Route path="/view-order/:id" element={<ViewOrder />} />
      </Routes>
    </Router>
  );
}

export default App;